module.exports = __webpack_public_path__ + "img/person.b0168351.svg";